module.exports = __webpack_public_path__ + "static/media/branding_img_right2.14e6f9fb.png";